import { type onAfterSaveType } from 'app/main/components/hooks/useModel';
import { DetailsEventsWrapper } from 'app/main/components/page-layouts';
import { sendNotification } from 'app/store/notifications/notificationsConnectionSlice';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (
			modifiedModel.crss_user_assigned_uid &&
			modifiedModel.crss_user_assigned_uid !== model.crss_user_modified_uid
		) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.crss_user_modified_uid,
						assignedTo: modifiedModel.crss_user_assigned_uid,
						title: 'Nuovo Corso assegnato',
						body: `${model.user_modified_title} ti ha assegnato a "${model.crss_title}".`,
						url: `${window.location.origin}/courses/details/${model.crss_uid}`,
						icon: 'school',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params =>
	DetailsEventsWrapper(params.modifiedModel)([sendSaveNotification(params)]);

export default { onAfterSave };
